import React, { useState, useEffect } from "react";
import "./findbilboard.css";
import Card1 from "../../images/card1.jpg";
import Card2 from "../../images/card2.jpg";
import PriceIcon from "../../images/price.png";
import Select from "react-select";
import FindImg from "../../images/freedisplay.png";
import Spinner from "../../images/spinner.png";
// import { useDispatch, useSelector } from "react-redux";
// import { getAllLeds } from "../../store/actions/main-action";
import axios from "axios";
import { KEY } from "../../api";
import {
  useNavigate,
  createSearchParams,
  Link,
  useParams,
  useSearchParams,
} from "react-router-dom";
import Modal from "react-modal";
import MapChart from "../MapChart.js/MapChart";
import { color } from "d3";

const customStyless = {
  control: (base, state) => ({
    ...base,
    background: "transparent",

    backgroundImage: 'url("../../images/inputImag.png")',
    height: "39px",

    borderRadius: "31px",

    borderColor: state.isFocused ? "#fff" : "#fff",

    boxShadow: state.isFocused ? null : null,
    "&:hover": {
      borderColor: state.isFocused ? "#fff" : "#fff",
    },
  }),
  menu: (base) => ({
    ...base,

    borderRadius: 0,
    position: "relative",
    zIndex: 10000656560,
    marginTop: 3,
  }),
  menuList: (base) => ({
    ...base,

    padding: "10px",

    backgroundColor: "#161119",
    // borderBottomLeftRadius: "20px"
  }),
  option: (base, { isFocused, isHovered, isActive, isSelected }) => ({
    ...base,
    backgroundColor: isFocused || isHovered ? "#161119" : "#161119",
    color: "#fff",

    "&:hover": {
      backgroundColor: "#161119",
      color: "#c060f1",
      cursor: "pointer",
    },
  }),
};
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "black",
    width: "600px",
    border: "1px solid #C060F1",
    borderRadius: "20px",
  },
};
Modal.setAppElement("#root");
const FindBilboard = () => {
  let { id } = useParams();
  let subtitle;
  const [modalIsOpen, setIsOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const [modalTwoIsOpen, setTwoIsOpen] = useState(false);

  const [page, setPage] = useState(0);
  const [modalPost, setModalPost] = useState(null);

  const [category, setCategory] = useState(null);
  const [options, setOptions] = useState([]);
  const posOptions = () => {
    KEY.get(`/leds/getCategories`, {
      headers: {
        "Accept-Language": "en",
        "Content-Type": "application/x-www-form-urlencoded",
      },
      withCredentials: true,
    })
      .then((response) => {
        const formattedOptions = response.data.map((cat) => ({
          value: cat.categoryId,
          label: cat.value,
        }));
        // setOptions(formattedOptions);

        setOptions([
          { value: "", label: "🗑 Clear Selection" },
          ...formattedOptions,
        ]);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    posOptions();
  }, []);
  const [selectedId, setSelectedId] = useState("");
  const [post, setPost] = useState(null);
  const [location, setLocation] = useState(
    searchParams.get("location") !== null ? searchParams.get("location") : ""
  );
  const [billboardName, setBillboardName] = useState("");
  const handleLocationChange = (e) => {
    setLocation(e.target.value);
    setSelectedId("");
  };

  const handleBillboardNameChange = (e) => {
    setBillboardName(e.target.value);
    setSelectedId("");
  };

  const postAllItemes = () => {
    KEY.get(
      `/leds/getAll?location=${location}&boardName=${billboardName}&categoryId=${selectedId}`,
      {
        headers: {
          "Accept-Language": "en",
          "Content-Type": "application/x-www-form-urlencoded",
        },
        withCredentials: true,
      }
    )
      .then((response) => {
        setPost(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    postAllItemes();
  }, [page, location, billboardName, selectedId, searchParams.get("location")]);
  const postItem = () => {
    KEY.get(`/leds?ledId=${id}`, {
      headers: {
        "Accept-Language": "en",
        "Content-Type": "application/x-www-form-urlencoded",
      },
      withCredentials: true,
    })
      .then((response) => {
        setModalPost(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    if (id) {
      postItem();
    }
  }, [id]);
  // console.log(post)
  function openModal() {
    navigate({ pathname: `/upload/${id}` });
    setIsOpen(true);
  }

  function afterOpenModal() {
    subtitle.style.color = "#fff";
  }

  function closeModal() {
    setIsOpen(false);
    navigate({ pathname: `/upload` });
  }

  function openSecondModal(e) {
    setTwoIsOpen(true);
  }

  function closeSecondModal() {
    setTwoIsOpen(false);
  }

  const handleChartClick = (e) => {
    e.preventDefault();
  };

  return (
    <div className="findBillboard">
      <div className="container">
        <div>
          <h1 className="findHeader">Find Your Perfect Digital Billboard</h1>
          <div className="addnewSearch">
            <div className="searchBtns">
              <form>
                <div className="findInput">
                  <input
                    type="text"
                    placeholder="Search by Location "
                    value={location}
                    onChange={handleLocationChange}
                  />
                  <span></span>
                </div>
                <div className="findInput">
                  <input
                    type="text"
                    placeholder="Search by billboard name"
                    value={billboardName}
                    onChange={handleBillboardNameChange}
                  />
                  <span></span>
                </div>
              </form>
            </div>
            <div className="searchBtns">
              <form>
                <div className="findInput searchBtn">
                  <Select
                    styles={customStyless}
                    options={options}
                    placeholder="Search by segment"
                    onChange={(selectedOption) =>
                      setSelectedId(selectedOption?.value)
                    }
                  />
                </div>
                <div className="findInput">
                  <Link onClick={openSecondModal}>Search</Link>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="find">
          <div className="findContent">
            {post?.length === 0 && <p>No results found</p>}

            {post?.map((item, index) => {
              return (
                <div className="findCards" key={item?.ledId}>
                  <Link to={`/upload/${item?.ledId}`} onClick={openModal}>
                    <div>
                      <img
                        className="findCardsImg"
                        src={`${process.env.REACT_APP_API_BASE_URL}/api/files?ledId=${item?.ledId}`}
                        alt="img"
                      />
                    </div>
                    <div className="cardTexts">
                      <p className="cardFirstText">{item?.billboardName}</p>
                      <p className="cardSecondText">{item?.location}</p>
                      <span>
                        {" "}
                        <img src={PriceIcon} alt="img" /> {item?.price}$
                      </span>
                    </div>
                  </Link>
                  <Link
                    to={`/uploadVideo/${item?.ledId}`}
                    className="coleredbtn findBtn"
                  >
                    Book
                  </Link>
                </div>
              );
            })}
          </div>
          <div className="findMap">
            <MapChart location={post} />
          </div>
        </div>
      </div>

      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
        {/* <button onClick={closeModal}>X</button> */}
        <div className="findModalCards">
          <h2 ref={(_subtitle) => (subtitle = _subtitle)}>
            {modalPost?.billboardName}
          </h2>
          <div>
            <img
              className="findCardsImg"
              src={`${process.env.REACT_APP_API_BASE_URL}/api/files?ledId=${id}`}
              alt="img"
            />
          </div>
          <div className="cardTexts">
            <p className="cardFirstText">{modalPost?.title}</p>
            <p className="cardSecondText">{modalPost?.description}</p>
            <span>
              {" "}
              <img src={PriceIcon} alt="img" /> Starting Price From{" "}
              {modalPost?.price}${" "}
              <b>*Pricing may vary based on selected time slots</b>
            </span>
            <div className="modalTable">
              <div className="modalTableContent">
                <p>Screens</p>
                <p>{modalPost?.screens}</p>
              </div>
              <div className="modalTableContent">
                <p>Size</p>
                <p>{modalPost?.size}</p>
              </div>
              <div className="modalTableContent">
                <p>Media Type </p>
                <p>{modalPost?.mediaType}</p>
              </div>
              <div className="modalTableContent">
                <p>Duration </p>
                <p>{modalPost?.duration}s</p>
              </div>
            </div>
          </div>

          <Link to={`/uploadVideo/${modalPost?.id}`} className="findBtn">
            Book
          </Link>
        </div>
      </Modal>

      <Modal
        isOpen={modalTwoIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeSecondModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
        {/* <button onClick={closeSecondModal}>X</button> */}
        <div className="findModalCards">
          <div className="findFree" ref={(_subtitle) => (subtitle = _subtitle)}>
            <img src={FindImg} alt="image" />
            <img src={Spinner} alt="image" className="spinnner"/>
           
            <h3>Searching for Free Displays...</h3>
            <p>
              Hang tight! Our AI is finding the best options tailored just for
              you.
            </p>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default FindBilboard;
